/* eslint-disable react-hooks/exhaustive-deps */
import Accordion from 'SpendController/Components/Accordian/Accordian';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	Header,
	HeaderSpan,
	InnerContainer,
	RefreshSpan,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	PREWORKSHOP_BASELINE_KPI_DATA,
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	combinePreWorkshopBaselineKpiData,
	PREWORKSHOP_PRELIMINARY_SAVINGS_KPI_DATA,
	combinePreWorkshopData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	getPreWorkshopBaselineSummaryKpis,
	getPreWorkshopPreliminarySavingsSummary,
} from 'utils/apiRequests';

function PreWorkshopTemplate() {
	const [preWorkShopBaselineKpiData, setPreWorkShopBaselineKpiData] = useState(
		PREWORKSHOP_BASELINE_KPI_DATA
	);
	const [
		preWorkShopPreliminaryKpiData,
		setPreWorkShopPreliminaryKpiData,
	] = useState(PREWORKSHOP_PRELIMINARY_SAVINGS_KPI_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSpendType = ['MACRO'];
	const {
		filters,
		preWorkShopColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const preWorkShopBaselineKpiDataResponse = await getPreWorkshopBaselineSummaryKpis(
			microFilters
		);
		const preWorkshopPreliminaryKpiResponse = await getPreWorkshopPreliminarySavingsSummary(
			microFilters
		);
		const tempPreWorkShopBaselineKpiData = combinePreWorkshopBaselineKpiData(
			preWorkShopBaselineKpiDataResponse.data,
			preWorkShopBaselineKpiData.data
		);
		setPreWorkShopBaselineKpiData({
			...preWorkShopBaselineKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		const newWorkShopKpiData = combinePreWorkshopData(
			preWorkshopPreliminaryKpiResponse,
			preWorkShopPreliminaryKpiData.data
		);
		setPreWorkShopPreliminaryKpiData({
			...preWorkShopPreliminaryKpiData,
			data: newWorkShopKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<BreakDownFilters />

			<InnerContainer>
				<Accordion name={`Pre-WorkShop  Health Bar`} idkey={'acc1'}>
					<InnerContainer>
						<Summary {...preWorkShopBaselineKpiData} />

						<Summary {...preWorkShopPreliminaryKpiData} />
					</InnerContainer>
				</Accordion>
			</InnerContainer>
			<ColumnContainer>
				<Header>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableWrapper n={7}>
					<TableView
						data={preWorkShopColumnDefs}
						columnDefs={preWorkShopColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default PreWorkshopTemplate;
